var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comments-container"},_vm._l((_vm.comments),function(comment){return _c('comments-item',{key:comment.id,attrs:{"comment":comment}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }